import React from 'react';
import { withTranslation } from 'react-i18next';
import { Segment, Container, Card, Image, Label, Icon, Button, Modal, Message, Grid, Popup, GridColumn} from 'semantic-ui-react';

import {withError} from 'modules/misc/ErrorPage.js';
import Utils from 'utils/Utils.js'
import LoadInline from '../loading/LoadInline.js';
import {colors, fontSizes, fonts, layout, shadow, spacings, buttons} from 'style';
import defaultAvatar from 'img/default-avatar.png';
import backgroundImgTop from 'img/rmdc-leaderboard-background-header.png'
import backgroundImgBottom from 'img/rmdc-leaderboard-background-footer.png'
//let backgroundImgBottom;
//import backgroundImgBackground from ''
let backgroundImgBackground;
import award_medal_icon from 'img/award_medal_icon.png'
import individual_icon from 'img/individual_icon.png'
import steps_icon from 'img/steps_icon.png'
import teal_checkmark_icon from 'img/teal_checkmark_icon.png'
import yellow_checkmark_icon from 'img/yellow_checkmark_icon.png'
import defaultObjectiveImage from 'img/default-challenge-image.jpg';
import _ from 'underscore';
import { PageNavigationBar } from 'components/tables'
import { ContentCard } from 'components/card.js';
import DeletePromptContainer from 'modules/misc/DeletePromptContainer.js';
import LeaderboardExportSelectModalContainer from "modules/leaderboards/modals/LeadboardExportSelectModalContainer.js"

let progressBarColor = '#74D2D6'
let checkMarkColor = '#43A0D5'
let textColor = '#000000'

var style = {
    content: {

        ...fonts.body,
        lineHeight: '1.5',
        marginLeft: 'auto',
        marginRight: 'auto',
        //maxWidth: '1000px',
        lineHeight: '1.5',
        ...fonts.body,
    },
     backgroundContainer:{
        position:"absolute",
        "top":0,
        zIndex: 0,
        "width":"100%", 
        height:"100%",
        //"object-fit": "cover"
    },
    backgroundTopContainer:{
        position:"absolute",
        "top":0,
        zIndex: 1,
        "width":"100vw", 
        height:"auto"
    },
    backgroundBottomContainer:{
        position:"absolute",
        "bottom":0,
        zIndex: 1,
        "width":"100vw",
        "height":"auto"
    },
    body: {
       //maxWidth: layout.screenWidth,
        boxShadow: layout.screenShadow,
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundColor: 'white',
        overflow:"hidden"
        //borderRadius: spacings.base
    },
    recordBarContainer: {
        position: 'relative',
    
        //marginTop: '0',
        marginBottom: '0',
        paddingTop: '0',
        paddingBottom: '0'
    },
    del: {
        position:'absolute',
        display: 'inline-block',
        borderRadius: '50%',
        height: '48px',
        width: '48px',
        fontSize: '0.8em',
        verticalAlign: 'middle',
        textAlign: 'center',
        top:'0px',
        left:'0px',
        lineHeight: '46px',
        backgroundColor:'white',
        border:'2px solid lightgrey',
        textIndent:'2px'

    },
    rank: {
        display: 'inline-block',
        height: '100%',
        fontSize: '1em',
        //width: '60px',
        verticalAlign: 'middle',
        textAlign: 'right',
        position: 'relative',
        //top: '3px',
        //lineHeight: '75px',
        color: textColor,
    },
    avatarContainer: {
        display: 'inline-block',
        height: '100%',
        fontSize: '1.5em',
        width: '180px',
        verticalAlign: 'middle',
        textAlign: 'left',
        position: 'relative',
        top: '-1px',
        lineHeight: '75px',
    },
    avatarWrapper: {
        position: 'relative',
        display: 'inline-block',
        borderRadius: '50%',
        height: '48px',
        width: '34px',
        verticalAlign: 'middle',
    },
    avatar: {
        backgroundPosition:'50% 50%',
        backgroundSize:'cover',
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: '#fff',
        borderRadius: '50%',
        height: '48px',
        width: '48px',
        verticalAlign: 'top',
    },
    recordBarBody: {
        //position: 'absolute',
        /*paddingLeft: '120px',*/
        // marginRight: '115px',
        left: '0px',
        top: '0px',
        //width: '100%',
        //height: '100%',
    },
    personInfo: {
        //marginTop: '20px',
        width: '100%',
        lineHeight: '1.1vw'
  
    },
    personalInfoSpan: {
        "width": "11vw",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    display: "inline-block",
    fontSize:'1vw'
    },
    companyName: {
        fontSize: '0.8vw',
        fontStyle: "italic"
    },
    personalInfoItem: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '100%',
        fontWeight: 'bold',
        color: textColor,
    },
    recordPoints: {
        height: '100%',
        width: '100px',
        color: textColor,
        float: 'right',
        fontSize: '1.1em',
        fontWeight: 'normal',
        //paddingTop: '38px',
        textAlign: 'right',
        //marginRight: spacings.base
        
    },
    icon: {
        position: 'relative',
        top: '2px',
        left:'-5px',
    },
    progressBar: {
        marginTop: '0',
        height: '10px',
        width: '100%',
        backgroundColor: progressBarColor,
        //background: 'linear-gradient(to right, '+colors.themeBlue+', '+colors.themeTeal+')',
        //borderRadius: '4px',
    },


    recordBar: {
        position: 'relative',
        padding: '8px',
        height: '64px',
        backgroundColor: textColor,
        borderTopRightRadius: '32px',
        borderBottomRightRadius: '32px'
    },
    textContainer: {
        display: 'table',
        tableLayout: 'fixed',
        width:'100%',
        height:'100%',
        paddingRight:'64px',
    },
    textClipper: {
        verticalAlign: 'middle',
        display: 'table-row',
        width:'100%',
        height: '100%',
        minWidth: '100px'
    },
    myRow: {
        backgroundColor: textColor,
        borderRadius: '6px',
    },
    myPoints: {
        color: '#fff',
    },
    myRank: {
        color: '#fff',
    },
    myProgressBar: {
        backgroundColor: '#fff',
        background: '#fff',
    },
    myInfo: {
        color: '#fff',
    },
    clickable: {
        cursor: 'pointer',
    },
    contentPic: {
        marginLeft: 'auto',
        marginRight: 'auto',
       // maxWidth: '1000px',
        lineHeight: '1.5',
        ...fonts.body,
    },
   
  
    starIcon: {
        position: 'absolute',
        left: '6px',
        top: '6px',
        fontSize: '1.5em',
        opacity: '1',
        color: '#FFF'
    },
 
    loader: {
        marginTop: '10px',
    },
    loaderContainer: {
        height: '100%',
    },

    participants: {
        fontSize: fontSizes.body,
        color: textColor
    },
    segment: {
        backgroundColor: 'white',
        //borderRadius: '9px',
        boxShadow: shadow,
        //margin: '1vw',
        //marginTop: '14vw',
       
        position: "absolute",
        zIndex: 100,
        top: "14vw",
        left: "2vw",
        right: "2vw",
        bottom: "2vw"
    },
    leaderboardSegment: {
      backgroundColor: 'white',
      //borderRadius: '9px',
      boxShadow: shadow,
      margin: '1vw',
      padding: spacings.base,
    },
    title: {
        padding: spacings.base,
        fontSize: fontSizes.h3,
        color: textColor,
        textAlign: 'center',
        lineHeight: '2.5',
    },
    h3: {
        fontSize: '2vw',
        color: textColor,
        fontWeight:"bold",
        paddingTop:'2vw',
        paddingBottom:'1vw',
        lineHeight:"2vw"
    },
    h4: {
        color: textColor,
        ...fonts.h4,
    },
    banner: {
        width: '100%',
        //borderTopRightRadius: '9px',
        //borderTopLeftRadius: '9px',
        height: '13.36vw',
        //objectFit: 'cover'
    },
    cardContent: {
        textAlign: 'center',
        //padding: spacings.base,
    },
    competitionTitle: {
        //paddingTop: '0',
        //paddingBottom: '0',
    },
    checkmark: {
        color : checkMarkColor
    },

    h4Milestone : {
        ...fonts.h4,
        color : colors.themeBlue,
        marginTop : spacings.base,
        marginBottom : spacings.base,
        textAlign: 'left'
    },
    bodyMilestones : {
        ...fonts.bodyL,
        justifyContent: 'left',
        color : colors.themeDarkerGrey
    },
    back : {
       fontSize: fontSizes.h4,
       position: 'absolute',
       color: colors.themeDarkerGrey,
       cursor: 'pointer'
    },
    starIconMilestone : {
        color: colors.pointsYellow,
        verticalAlign: 'baseline'
    },
    resourcesIcon : {
        color: colors.pointsBlue,
    },
    pointsCell : {
        padding : '0px'
    },
    slimRow : {
        paddingBottom: spacings.micro,
        paddingTop :spacings.micro
    },
    gridContent : {
        marginTop: '32px',
    },
    segmentBoxes : {
        backgroundColor: 'white',
        //borderRadius: '9px',
        boxShadow: shadow,
        textAlign: 'left',
        padding: spacings.base,
        height: '350px',
        width: '470px',
        marginTop: '-16px'
    },
    avatarLabelContainer: {
        width: '100%', 
        height:'32px',
        marginTop: '-3px',
        padding: '4px',
        marginLeft: '8px'
    },
    avatarLabel: {
        textAlign: 'right',
        backgroundColor: '#fff',
        color: colors.themeBlue,
        fontWeight: 'normal',
        position: 'relative',
        fontSize: '14px',
        borderRadius: '100px',
        marginRight: '4px'

    },
    pointsLabel: {
        color: colors.themeBlack,
    },
    checkmarkMilestone : {
        color : 'green'
    },
    x : {
        color : 'red'
    },
    title: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    iconButtonTrashIcon: {
 
        opacity: '1',
        color: colors.warningRed,
    },
    iconBadge: {
        verticalAlign: "middle",
        width:fontSizes.body,
        height:fontSizes.body,
        marginLeft: '0.3vw',
        //marginBottom: '0.5vw'
    },
    iconImage: {
        verticalAlign: "middle",
        width:"1.8vw",
        height:"1.8vw",
        marginRight: '1.5vw',
        marginBottom: '0.5vw'
    },
    iconLabel: {
        fontSize: "1.3vw"
    }
};

const rankSortFunc = x => {
    var rank = x.rank;
    if(rank === null || rank === undefined) {
        return Number.MAX_VALUE;
    }
    return rank;
}
const ranks = {
    // 1:{color: colors.pointsYellow},
    // 2:{color: '#C0C0C0'},
    // 3:{color: '#CD7F32'},
}
const avatars = {
    1:{borderColor: colors.pointsYellow},
    2:{borderColor: '#C0C0C0'},
    3:{borderColor: '#CD7F32'},
}

const LeaderboardRMDC2026 = ({t,
                      //records,
                      leaderboard,
                      targetPoints,
                      column,
                      busy,
                      onClickChange,
                      start,
                      limit,
                      total,
                      isMember,
                      isClickable,
                      getName,
                      getCompany,
                      dailyMetric,
                      dailyGoal,
                      getAvatars,
                      formatLeaderboardValue,
                      onExport,
                      downloadLinkRef,
                      deleteModalRef,
                      changePage,
                      onDeleteMember,
                      isHovering,
                      handleMouseOver,
                      handleMouseOut,
                      onSelectExportType,
                      showExportSelectModalContainer,
                      setShowExportSelectModalContainer,
                      columns
                    }) => {
return busy ? (
        <div style={style.loaderContainer}>
                <LoadInline centered vcentered /> 
        </div>
) : (
    <>

    <img style={style.backgroundContainer} src={backgroundImgBackground}/>

    <img style={style.backgroundTopContainer} src={backgroundImgTop}/>

    <img style={style.backgroundBottomContainer} src={backgroundImgBottom}/>

{Boolean(leaderboard) &&
  

    
  <div style={style.segment}>
  {/* <img style={style.banner} alt='' src={splashBanner} /> */}
  <div style={style.cardContent}>
      <div style={{...style.h3, ...style.competitionTitle}}>{leaderboard.title} Leaderboard</div>
      <Grid columns="16" style={{width:"90vw", marginBottom:"0.5vw", marginTop:"0.3vw"}}>
          <Grid.Row>
              <GridColumn width={8} style={{borderRight:"0.1vw solid black"}}>
                  <img src={award_medal_icon} style={{...style.iconImage}}/>
                  <span style={{...style.iconLabel}}>{leaderboard.type == 'teams' ? 'Team Competition' : 'Compete Solo. Climb the Leaderboard. Win Big!'}</span>
              </GridColumn>
              <GridColumn width={4} style={{borderRight:"0.1vw solid black"}}>
                  <img src={individual_icon} style={{...style.iconImage}}/>
                  <span style={{...style.iconLabel}}>{total == 1 ? total + ' ' + t(leaderboard.type == 'teams' ? 'Team' : 'Participant') : total.toLocaleString() + ' ' + t(leaderboard.type == 'teams' ? 'Teams' : 'Participants')}</span>
              </GridColumn>
              {/* <GridColumn>
                  <img src={steps_icon} style={{...style.iconImage}}/>
                  <span style={{...style.iconLabel}}>Total Daily Steps</span>
              </GridColumn> */}
              <GridColumn width={4}>
                  <img src={teal_checkmark_icon} style={{...style.iconImage}}/>
                  <span style={{...style.iconLabel}}>Step Goal Hit Today</span>
              </GridColumn>
              {/* <GridColumn>
                  <img src={yellow_checkmark_icon} style={{...style.iconImage}}/>
                  <span style={{...style.iconLabel}}>Super Strider (12k+)</span>
              </GridColumn> */}
          </Grid.Row>
      </Grid>
      
       
  </div>

<Grid columns="equal">
  <Grid.Row>
  { columns && leaderboard && columns.map((records) => { 
      return (<Grid.Column>
<Grid style={{width:'20vw', margin:"0 auto"}}>
{records && leaderboard && records.map((record) => {
  let scope = record.team ? 'team' : 'userProfile'
  return (
      
 
      <Grid.Row key={record.id} style={{...style.recordBarContainer, ...(isMember(record) ? style.myRow : {}), ...(isClickable(record) ? style.clickable : {}), margin:"0.3vw"}} onClick={() => onClickChange(record)}>

          <Grid.Column width={1} style={{...style.rank, padding:"0"}}>
              {record.rank}
          </Grid.Column>
          
          {/* <Grid.Column width={2} style={style.avatarContainer}  onMouseEnter={()=>handleMouseOver(record)} onMouseLeave={()=>handleMouseOut(record)}>
              {getAvatars(record[scope]).map((url,avatarIndex)=>(
                  <div key={avatarIndex}>{record.isHovering}
                          <div  style={style.avatarWrapper}><div style={{...style.avatar, ...(avatars[record.rank]), backgroundImage:Utils.url(url ? url : defaultAvatar)}} /><div style={{...style.avatarWrapper, ...style.clickable, ...style.del, visibility: record.isHovering ? 'visible' : 'hidden'}} onClick={()=>{
                      deleteModalRef.current.showDeletePrompt(record)
                  }}><Icon style={style.iconButtonTrashIcon} name='trash' /></div></div>
                          
                          
                  </div>
                  
              ))}
          </Grid.Column> */}

          <Grid.Column width={15} style={{...style.recordBarBody}}>

          
              <div style={style.personInfo}>
                  <span style={style.personalInfoSpan}>
                  {getName(record[scope])} <span style={style.companyName}>{getCompany(record[scope])}</span>
           
                  
                  </span>
                  <span style={{float:"right"}}>
                  
                  { 
                      ( dailyMetric(record[scope]) >= dailyGoal(record[scope])  ? <img src={teal_checkmark_icon} style={{...style.iconBadge}}/> :
                      <div style={{...style.iconBadge}}></div>)
                      
                  } 

       
                  </span>
                  <span style={{float:"right"}}>
              <i style={style.icon} className={leaderboard.icon} />
              {formatLeaderboardValue(record, column)?.toLocaleString()}
       
                  </span>
                  
              </div>
              <div style={{...style.progressBar, ...(isMember(record) ? style.myProgressBar : {}), width:(record[scope].anonymous ? '0%' : String(Utils.getPercent(record[column], targetPoints))+'%')}} />
          </Grid.Column>
      </Grid.Row>
      
  )
})
}
</Grid>
</Grid.Column>) }) }
  </Grid.Row>
</Grid>
</div>


}
</>

)};



export default withTranslation('leaderboards')(LeaderboardRMDC2026);
